import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { COMMENTS_SUMMARY_COMPONENT_INTERACTION } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const COMMENTS_SUMMARY_INTERACTION_METRIC = createInteractionMetric({
	key: COMMENTS_SUMMARY_COMPONENT_INTERACTION,
});
